import { isObject } from '@dimjs/lang';
import { classNames, extend } from '@dimjs/utils';
import { ReactElement } from 'react';
import { ArrowIcon, ArrowIconProps } from '../icon';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import './style.less';
import { ListItemVarStyle } from './type';

export type ListItemProps = {
  // 列表项左侧区域
  prefix?: string | ReactElement;
  // 列表项右侧区域
  extra?: string | ReactElement;
  onClick?: (e: React.MouseEvent) => void;
  title?: string | ReactElement;
  description?: string | ReactElement;
  arrow?: true | ArrowIconProps;
  icon?: ReactElement;
} & CommonPropsWithChildren<ListItemVarStyle>;

const classPrefix = 'v-list-item';

/**
 * @param props
 * @returns
 * ```
 * 1. 自定义icon 在未设置arrow情况下有效
 * ```
 */
export const ListItem = (props: ListItemProps) => {
  const showArrowIcon = !!props.arrow;
  const arrowIconPorps = extend({}, isObject(props.arrow) ? props.arrow : {}, {
    className: classNames(`${classPrefix}-arrow`, isObject(props.arrow) ? props.arrow?.['className'] : ''),
  });

  return withNativeProps(
    props,
    <div className={classNames(classPrefix, { clickable: props.onClick })} onClick={props.onClick}>
      {props.prefix ? <div className={`${classPrefix}-prefix`}>{props.prefix}</div> : null}
      <div className={`${classPrefix}-main`}>
        {props.title ? <div className={`${classPrefix}-title`}>{props.title}</div> : null}
        {props.children ? <div className={`${classPrefix}-content`}>{props.children}</div> : null}
        {props.description ? <div className={`${classPrefix}-description`}>{props.description}</div> : null}
      </div>
      {props.extra && <div className={`${classPrefix}-extra`}>{props.extra}</div>}
      {showArrowIcon ? <ArrowIcon {...arrowIconPorps} /> : props.icon}
    </div>,
  );
};
